import BaseModel from "../../BaseModal"
import { getDateWithTime } from "../../utils";
import { FlexWrapperCenter, GapView, LineView } from "../../styles/WrapperStyles";
import styled, { css } from "styled-components";
import './Modal.css';

const ParentDiv = styled.div`
  width: 1100px;
  height: 339px;
  border-radius: 20px;
`;

const TextView = styled.p`
  font-family: 'Gilory-Semi';
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #484848;
  text-align: center;
  ${props =>
    props.small &&
    css`
      font-size: 16px;
    `}
`;

const TitleView = styled.div`
  font-family: 'Gilroy-Bold';
  font-size: 20px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #484848;
  text-align: center;
`;

const ProfileLogHistoryListModal = (props) => {
    return (
        <BaseModel closeModal={props.closeModal}>
            <ParentDiv>
                <TitleView>Profile Log History</TitleView>
                {props.map((item, pos) => {
                    return (
                        <div key={pos}>
                            <FlexWrapperCenter>
                                <TextView>{getDateWithTime(item.time)}</TextView>
                                <GapView width="20px" />
                                <TextView className="width50Percent">
                                    {item.curator}
                                </TextView>
                                <GapView width="20px" />
                                <TextView>{item.name} {item.reason}</TextView>
                            </FlexWrapperCenter>
                            <LineView />
                        </div>
                    );
                })}
            </ParentDiv>
        </BaseModel>
    )
}

export default ProfileLogHistoryListModal